<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<!-- 选项卡 -->
			<div class="navBox f-ct">
				<p @click="newsType=1" :class="newsType==1?'a':''">企业信息</p>
				<p @click="newsType=2" :class="newsType==2?'a':''">开票信息</p>
			</div>
			<!-- 用户信息 -->
			<div class="userMsg" v-if="newsType==1">
				<!-- 基础信息 -->
				<div class="f-bct">
					<div class="company">
						<div class="lable">企业信息</div>
						<div class="detail flex">
							<el-image :src="companyInfo.logo"></el-image>
							<div class="r">
								<p class="name">{{companyInfo.companyName}}</p>
								<p class="t1">社会统一信用代码：{{companyInfo.companyCreditCode}}</p>
							</div>
						</div>
					</div>
				</div>
				<!-- 表单 -->
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">手机号码</div>
						<div class="detail f-ct">
							<el-input type="text" disabled v-model="mobile" placeholder="请输入手机号码"></el-input>
							<div class="anniu" @click="hbMobile=true">更换</div>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">登录密码</div>
						<div class="detail f-ct">
							<el-input type="password" disabled :value="123456" placeholder="请输入登录密码"></el-input>
							<div class="anniu" @click="hbPwd=true">重置</div>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<!-- <div class="formBox">
						<div class="lable">用户名</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="mobile" placeholder="请输入用户名"></el-input>
						</div>
					</div> -->
					<div class="formBox">
						<div class="lable">企业地区</div>
						<div class="detail" v-if="regionList.length">
							<el-cascader
							style="width: 100%;"
							placeholder="请选择地址"
							:props="{children:'childList',label:'name',value:'id'}"
							v-model="regionVal"
							:options="regionList"></el-cascader>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">企业详细地址</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="address" placeholder="请输入企业详细地址"></el-input>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">企业联系人</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="contact" placeholder="请输入企业联系人"></el-input>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">企业邮箱</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="email" placeholder="请输入企业邮箱"></el-input>
						</div>
					</div>
				</div>
				<div class="f-bct">
					<div class="formBox">
						<div class="lable">银行账户</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="bankAccount" placeholder="请输入银行账户"></el-input>
						</div>
					</div>
					<div class="formBox">
						<div class="lable">开户行</div>
						<div class="detail f-ct">
							<el-input type="text" v-model="openingBank" placeholder="请输入开户行"></el-input>
						</div>
					</div>
				</div>
				<!-- 基础信息 -->
				<div class="f-bct">
					<div class="userImgBox f-ct">
						<div class="itm">
							<div class="lable">营业执照扫描件</div>
							<div class="detail">
								<el-upload accept="image/png, image/jpeg" 
								class="avatar-uploader"
								:action="uplink"
								:show-file-list="false"
								:on-change="businessLicenseImageF">
									<el-image v-if="!businessLicenseImage" :src="require('@/static/img2.png')"></el-image>
									<el-image v-else fit="cover" :src="businessLicenseImage"></el-image>
								</el-upload>
							</div>
						</div>
					</div>
				</div>
				<div class="pageAnniuBox f-ct">
					<!-- <div class="b1">编辑资料</div> -->
					<div class="b1" @click="authMemberprofile">保存修改</div>
					<!-- <div class="b2">取消</div> -->
				</div>
				<div class="pageTips">用户名和企业名称已被设置为不可修改，如需修改，请联系海南省燃气协会燃气从业人员培训教育信息平台</div>
			</div>
			<!-- 开票信息 -->
			<div class="kpBox" v-if="newsType==2">
				<div class="pageAnniuBox f-ct">
					<div class="b1" style="width: auto;" @click="link('/userMsgKp')">添加开票信息</div>
				</div>
				<div class="zw" v-if="!kpxxList.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="kfpTable" v-if="kpxxList.length">
					<div class="th f-ct">
						<p class="t1">序号</p>
						<p class="t2">开票信息类型</p>
						<p class="t3">单位名称</p>
						<p class="t4">纳税人识别号</p>
						<!-- <p class="t5">姓名</p> -->
						<p class="t6">邮箱</p>
						<p class="t7">操作</p>
					</div>
					<div class="td f-ct" v-for="(item,index) in kpxxList">
						<div class="t1">{{item.id}}</div>
						<div class="t2" v-if="item.invoiceType==1">普通发票(个人)</div>
						<div class="t2" v-if="item.invoiceType==2">普通发票(单位)</div>
						<div class="t2" v-if="item.invoiceType==3">专用发票(单位)</div>
						<div class="t3">{{item.title}}</div>
						<div class="t4" v-if="item.invoiceType!=1">{{item.code}}</div>
						<div class="t4" v-if="item.invoiceType==1">/</div>
						<!-- <div class="t5" v-if="item.invoiceType==1">{{item.name}}</div>
						<div class="t5" v-else>/</div> -->
						<div class="t6" v-if="item.invoiceType!=3">{{item.email}}</div>
						<div class="t6" v-if="item.invoiceType==3">/</div>
						<div class="t7">
							<p class="txt1" @click="link('/userMsgKp',{id:item.id})">编辑</p>
							<p class="bor"></p>
							<p class="txt2" @click="memberInvoicedelete(item.id)">删除</p>
						</div>
					</div>
				</div>
				<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
				</div>
			</div>
		</div>
		<!-- 弹出框 重置密码 -->
		<div class="maskBg" @click="hbPwd=false" v-if="hbPwd"></div>
		<div class="subTips" v-if="hbPwd">
			<div class="hbTit f-bct">
				<p>重置密码</p>
				<el-image class="cha" @click="hbPwd=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="iptBox">
				<div class="lable">用户手机号</div>
				<div class="ipt">
					<el-input type="text" disabled v-model="mobile" placeholder="请输入手机号"></el-input>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">手机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="code" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="authMemberregCaptcha">{{codetxt}}</div>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">输入新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="password" placeholder="请输入新密码"></el-input>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">确认新密码</div>
				<div class="ipt">
					<el-input type="password" v-model="confirmPassword" placeholder="请确认新密码"></el-input>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbPwd=false">返回</div>
				<div class="b2" @click="authMemberrestPassword">确认</div>
			</div>
		</div>
		<!-- 弹出框 更换手机号 -->
		<div class="maskBg" @click="hbMobile=false" v-if="hbMobile"></div>
		<div class="subTips" v-if="hbMobile">
			<div class="hbTit f-bct">
				<p>更换手机号</p>
				<el-image class="cha" @click="hbMobile=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="nowpone">当前绑定手机号:{{mobileSuss}}</div>
			<div class="iptBox">
				<div class="lable">旧机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="ocode" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="ocodetxtF()">{{ocodetxt}}</div>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">新手机号码</div>
				<div class="ipt">
					<el-input type="text" v-model="newMobile" placeholder="请输入新手机号码"></el-input>
				</div>
			</div>
			<div class="iptBox">
				<div class="lable">手机验证码</div>
				<div class="ipt f-bct code">
					<el-input type="text" v-model="newMobileCode" placeholder="请输入验证码"></el-input>
					<div class="codeBtn" @click="ncodetxtF()">{{ncodetxt}}</div>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbMobile=false;">返回</div>
				<div class="b2" @click="authMemberupdateMobile">提交</div>
			</div>
		</div>
	</div>
</template>
<script>
import { memberInvoiceListQY,
memberInvoicedeleteQY,
authCompanyInfo,
regioncityTree,
authMemberupdateMobileQY,
authMemberrestPasswordQY,
authMemberregCaptcha,
authCompanyprofilee
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let oic;
let nic;
let ic;
var nub = 120;
export default {
	data(){
		return {
			hbPwd:false,
			hbMobile:false,
			newsType:1,
			companyInfo:'',
			mobile:'',
			address:'',
			contact:'',
			email:'',
			openingBank:'',
			bankAccount:'',
			businessLicenseImage:'',
			// 地址
			regionList:[],
			regionVal:'',
			// 开票信息
			kpxxList:[],
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 修改手机号
			mobileSuss:'',
			ocodetxt:'发送验证码',
			ocode:'',
			newMobile:'',
			ncodetxt:'发送验证码',
			newMobileCode:'',
			// 重置密码
			codetxt:'发送验证码',
			code:'',
			password:'',
			confirmPassword:'',
		}
	},
	mounted() {
		// 获取信息
		this.regioncityTree()
		this.memberInvoiceList()
		setTimeout(()=>{
			this.getinfo()
		},500)
	},
	methods:{
		// 更新用户信息 学员
		async authMemberprofile(){
			if(!this.contact){this.Tips('请输入企业联系人','error');return}
			if(!this.email){this.Tips('请输入企业邮箱','error');return}
			if(!this.bankAccount){this.Tips('请输入银行账户','error');return}
			if(!this.openingBank){this.Tips('请输入开户行','error');return}
			if(!this.regionVal){this.Tips('请选择省市区','error');return}
			if(!this.address){this.Tips('请输入企业详细地址','error');return}
			// var laborContractImage = []
			// this.laborContractImage.forEach((item)=>{
			// 	laborContractImage.push(item.url)
			// })
			let res;
			var data = {
				provinceId:this.regionVal[0],
				cityId:this.regionVal[1],
				districtId:this.regionVal[2],
				address:this.address,
				bankAccount:this.bankAccount,
				openingBank:this.openingBank,
				contact:this.contact,
				email:this.email,
				businessLicenseImage:this.businessLicenseImage,
			}
			res = await authCompanyprofilee(data);
			if(res.code==200){
				this.getinfo()
				this.Tips(res.msg,'success')
			}else{this.Tips(res.msg,'error')}
		},
		// 重置密码
		async authMemberrestPassword(){
			const res = await authMemberrestPasswordQY({
				code:this.code,
				mobile:this.mobile,
				password:this.password,
				confirmPassword:this.confirmPassword,
			});
			this.hbPwd=false
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 修改手机
		async authMemberupdateMobile(){
			const res = await authMemberupdateMobileQY({
				code:this.ocode,
				newMobile:this.newMobile,
				newMobileCode:this.newMobileCode,
			});
			this.hbMobile=false
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.getinfo()
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async authMemberregCaptcha(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		async ocodetxtF(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				oic = setInterval(()=>{
					nub--
					that.ocodetxt = nub+'s'
					if(nub<=0){
						that.ocodetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		async ncodetxtF(){
			var that = this
			if(!this.checkModbile(this.newMobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.newMobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				oic = setInterval(()=>{
					nub--
					that.ncodetxt = nub+'s'
					if(nub<=0){
						that.ncodetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
		// 获取开票信息 列表
		async memberInvoiceList(def){
			if(def){this.pageNum = 1}
			const res = await memberInvoiceListQY({
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			});
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.kpxxList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 删除开票信息
		async memberInvoicedelete(id){
			const res = await memberInvoicedeleteQY({id});
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.memberInvoiceList(1)
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.memberInvoiceList()
		},
		// 获取用户信息 企业
		async getinfo(){
			let res;
			res = await authCompanyInfo({});
			if(res.code==200){
				this.$store.commit('userMsg/userInfoC',res.data);
				// this.manInfo = res.data.member
				this.companyInfo = res.data.company
				if(this.companyInfo.provinceId){
					this.regionVal = [this.companyInfo.provinceId,this.companyInfo.cityId,this.companyInfo.districtId]
				}
				this.mobile = res.data.company.mobile
				this.address = res.data.company.address
				this.contact = res.data.company.contact
				this.email = res.data.company.email
				this.openingBank = res.data.company.openingBank
				this.bankAccount = res.data.company.bankAccount
				this.businessLicenseImage = res.data.company.businessLicenseImage
				this.mobileSuss = res.data.company.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
			}else{this.Tips(res.msg,'error')}
		},
		// 获取tree结构的列表
		async regioncityTree(){
			let res = await regioncityTree({});
			if(res.code==200){
				this.regionList = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 上传营业执照
		businessLicenseImageF(file) {
			if(file.response){
				this.businessLicenseImage = file.response.data.url;
			}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 24px;
	padding-bottom: 40px;
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	padding: 0 10px;
	p{
		padding-top: 24px;
		padding-bottom: 16px;
		margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #3B6492;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.userMsg{
	padding-left: 8px;
	padding-top: 6px;
	padding-right: 64px;
	// padding-bottom: 50px;
	.pageTips{
		font-size: 14px;
		color: #FF5F5A;
		margin-top: 16px;
	}
	.pageAnniuBox{
		margin-top: 40px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}

	.userImg{
		width: 680px;
		// margin-right: 94px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			.el-image{
				width: 134px;
				height: 134px;
				border-radius: 6px;
			}
		}
	}
	.userImgBox{
		width: 680px;
		.itm{
			width: 202px;
			margin-right: 32px;
			&:last-child{
				margin-right: 0;
			}
			.lable{
				font-size: 16px;
				color: #3B3C3E;
				font-weight: bold;
				padding-top: 26px;
				padding-bottom: 12px;
				span{
					font-size: 14px;
					color: #969696;
					font-weight: normal;
				}
			}
			.detail{
				.el-image{
					width: 202px;
					height: 134px;
					border-radius: 6px;
				}
			}
		}
	}
	.company{
		width: 680px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			.el-image{
				width: 104px;
				height: 104px;
				border-radius: 6px;
				margin-right: 17px;
			}
			.r{
				width: calc(100% - 151px);
				.name{
					font-size: 18px;
					color: #3B3C3E;
					margin-bottom: 12px;
					font-weight: bold;
				}
				.t1{
					font-size: 16px;
					color: #3B3C3E;
					margin-bottom: 6px;
				}
			}
		}
	}
	.formBox{
		width: 680px;
		.lable{
			font-size: 16px;
			color: #3B3C3E;
			font-weight: bold;
			padding-top: 26px;
			padding-bottom: 12px;
			span{
				font-size: 14px;
				color: #969696;
				font-weight: normal;
			}
		}
		.detail{
			width: 100%;
			height: 46px;
			border-radius: 6px;
			border: 1px solid #E8EDF4;
			background: #FBFCFF;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
		}
		.selAddr{
			.selAddrItm{
				width: 212px;
				height: 46px;
				border-radius: 6px;
				border: 1px solid #E8EDF4;
				background: #FBFCFF;
				margin-right: 22px;
				&:last-child{
					margin-right: 0;
				}
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					height: 44px;
					background: transparent;
				}
			}
		}
	}
}

.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 41px;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.nowpone{
		font-size: 16px;
		color: #3B6492;
		margin-bottom: 24px;
		text-align: center;
	}
	.iptBox{
		display: flex;
		align-items: center;
		margin-bottom: 20px;
		justify-content: center;
		.lable{
			font-size: 16px;
			color: #9A9DA7;
			margin-right: 30px;
		}
		.code{
			.el-input{
				width: calc(100% - 106px)!important;
			}
			.codeBtn{
				color: #3B6492;
				font-size: 16px;
				cursor: pointer;
			}
		}
		.ipt{
			width: 307px;
			height: 46px;
			border-radius: 8px;
			border: 1px solid #E8EDF4;
			padding-left: 20px;
			padding-right: 16px;
			.anniu{
				font-size: 16px;
				color: #3B6492;
				cursor: pointer;
			}
			.el-input{
				width: calc(100% - 36px);
			}
			.el-select{
				width: calc(100% - 36px);
			}
			::v-deep .el-input__inner{
				height: 44px;
				padding: 0;
				border: none;
				background: transparent;
			}
		}
	}
	.btnBox{
		margin-top: 32px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.kpBox{
	.pageAnniuBox{
		margin-top: 24px;
		div{
			width: 148px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			padding: 0 26px;
			margin-right: 24px;
			cursor: pointer;
		}
		.b2{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b1{
			background: #3B6492;
			color: #fff;
			
		}
	}
	.kfpTable{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		margin-top: 24px;
		// margin-bottom: 40px;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 370px;
			}
			.t4{
				width: 477px;
			}
			.t5{
				width: 137px;
			}
			.t6{
				width: 234px;
			}
			.t7{
				width: 169px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				line-height: 26px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 16px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 80px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 370px;
			}
			.t4{
				width: 477px;
			}
			.t5{
				width: 137px;
			}
			.t6{
				width: 234px;
			}
			.t7{
				width: 169px;
				.bor{
					width: 1px;
					height: 14px;
					background: #E2E2E2;
					margin: 0 18px;
				}
				.txt1{
					font-size: 14px;
					color: #3B6492;
					cursor: pointer;
				}
				.txt2{
					font-size: 14px;
					color: #FF5F5A;
					cursor: pointer;
				}
			}
		}
	}
}
</style>